import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";
import user from "@/services/user.service";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: localStorage.getItem('token') || '',
        companyType: localStorage.getItem('companyType') || '',
        isAdmin: localStorage.getItem('isAdmin') || false,
        approveStatus: localStorage.getItem('approveStatus') || '',
        returnUrl: "",
        needUpdateTrackers: false,
        needUpdateUsers: false,
        needUpdateStartups: false,
        needUpdateEcosystems: false,
        needUpdateEnterprises: false,
        needUpdateTasks: false,
        needLogout: false,
        addStartup: false,
        addEcosystem: false,
        addEnterprise: false,
        openCompanyProfile: false,
        canLoadGlobalComponents: false,

        user : {
            id: 0,
            name: "",
            avatar: "",
            company_type: "",
            company_name: "",
            company_website: "",
            company_url: "",
            company_profile_text: "",
            company_logo: "",
            is_admin: false,
            permissions: [],
            admin_groups: [],
            show_company_profile_form: false,
            settings: {
                hide_no_folders: 1,
                search_big_companies: 0,
            },
            qrveyapp_id: '',
        },

        newMessages: [],

        pageNotFound: false,
    },

    mutations: {
        authSuccess(state, user) {
            state.token = user.token
            localStorage.setItem('token', user.token)
            this.commit('setUserSettings', user)
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + user.token
        },

        authError(state){
            state.token = ''
            localStorage.removeItem('token');
        },

        updateUserData() {
            user.getCurrentUserData().then(response => {
                this.commit('setUserSettings', response.data)
            })
        },

        setUser(state, user) {
            this.commit('setUserSettings', user)
        },

        setUserSettings(state, user) {
            state.user = user
            state.companyType = user.company_type
            localStorage.setItem('companyType', user.company_type)
            state.isAdmin = user.is_admin
            localStorage.setItem('isAdmin', user.is_admin)
            if (typeof user.approve_status !== 'undefined') {
                state.approveStatus = user.approve_status
                localStorage.setItem('approveStatus', user.approve_status)
            }
        },

        logout(state) {
            state.user = {}
            state.token = ''
            state.companyType = ''
            localStorage.removeItem('token')
            localStorage.removeItem('companyType')
        },

        setPageNotFound(state, value) {
            state.pageNotFound = value
        },

        setReturnUrl(state, value) {
            state.returnUrl = value
        },

        setNeedUpdateTrackers(state, value) {
            state.needUpdateTrackers = value
        },

        setNeedUpdateUsers(state, value) {
            state.needUpdateUsers = value
        },

        setNeedUpdateStartups(state, value) {
            state.needUpdateStartups = value
        },

        setNeedUpdateEcosystems(state, value) {
            state.needUpdateEcosystems = value
        },

        setNeedUpdateEnterprises(state, value) {
            state.needUpdateEnterprises = value
        },

        setNeedUpdateTasks(state, value) {
            state.needUpdateTasks = value
        },

        setNeedLogout(state, value) {
            state.needLogout = value
        },

        setAddStartup(state, value) {
            state.addStartup = value
        },

        setAddEcosystem(state, value) {
            state.addEcosystem = value
        },

        setAddEnterprise(state, value) {
            state.addEnterprise = value
        },

        setOpenCompanyProfile(state, value) {
            state.openCompanyProfile = value
        },

        setNewMessages(state, value) {
            state.newMessages = value
        },

        setCanLoadGlobalComponents(state, value) {
            state.canLoadGlobalComponents = value
        },
    },

    getters : {
        isLoggedIn: state => state.token.length > 0,
        isEnterprise: state => state.user.company_type == "enterprise",
        isEcosystem: state => state.user.company_type == "ecosystem",
        isAdmin: state => state.isAdmin === 'true' || state.isAdmin === true,
    },
})